// extracted by mini-css-extract-plugin
export default {"Shelf":"ZlUAI5d5","Spacer":"xr7ZHccp"};